import { render, staticRenderFns } from "./ActiveTelnyx.vue?vue&type=template&id=3e9cbfc4&"
import script from "./ActiveTelnyx.vue?vue&type=script&lang=js&"
export * from "./ActiveTelnyx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports